/**
 * Member Maintenance Modal Controller
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;

	const modal = document.getElementById('js-member-maintenance-modal');
	const triggers = document.querySelectorAll('.js-member-maintenance-modal-trigger');
	const closeBtn = document.getElementById('js-member-maintenance-close');

	if (!modal || !triggers.length || !closeBtn) return;

	const toggleModal = (show) => {
		modal.classList.toggle('--visible', show);

		if (show) {
			closeBtn.setAttribute('tabindex', '0');
			closeBtn.focus();
		} else {
			closeBtn.setAttribute('tabindex', '-1');
		}

		if (debug) console.log(`Modal ${show ? 'opened' : 'closed'}`);
	};

	triggers.forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleModal(true);
		});
	});

	modal.addEventListener('click', () => {
		toggleModal(false);
	});
};
